define([
	"./_Flip",
	"./PluginFactory"
], function(_Flip, PluginFactory) {

	return PluginFactory.declare(_Flip, {
		degrees: -90,
		materialIcon: "rotate_90_degrees_ccw",
		pluginName: "rotate90CCW",
		title: "CanvasRotate90CCW"
	});
});
